import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Route, Redirect, RouteProps } from "react-router-dom";
// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.

const mapStateToProps = (state: {
  account: { loggedIn: boolean; wasAdmin: boolean; token: string; refreshtoken: string };
}) => ({
  loggedIn: state.account.loggedIn,
  wasAdmin: state.account.wasAdmin,
  token: state.account.token,
  refreshtoken: state.account.refreshtoken,
});
const mapDispatch = {};
const connector = connect(mapStateToProps, mapDispatch);

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps &
  RouteProps & {
    loggedIn: boolean;
  };

let PrivateRoute: React.FC<Props> = (props: Props) => {
  return (
    <Route
      render={({ location }) =>
        props.loggedIn && props.token !== "" && props.refreshtoken !== "" ? (
          props.children
        ) : (
          <Redirect
            to={{
              pathname: props.wasAdmin ? "/login/admin" : "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default connector(PrivateRoute);
